import index from "@/pages/company/group/Index";

export default [
    {
        path: 'company-group',
        name: 'company-group',
        meta: {
            title: '单位分组修改-单位管理'
        },
        component: index,
    },
]


// WEBPACK FOOTER //
// ./src/router/company/group/index.js